<template>
  <div class="ratio3">
    <div v-for="(v, i) in shares" :key="i" class="ratio3-row">
      <span class="ratio3-label">{{ partLabels[i] }}</span>
      <div class="ratio3-track">
        <div class="ratio3-fill" :style="{ width: `${(v * 100).toFixed(1)}%` }" />
      </div>
      <span class="ratio3-value mono">{{ pct(v) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { pct } from "@/lib/format";

const props = withDefaults(
  defineProps<{
    parts: [number, number, number] | number[];
    partLabels?: [string, string, string];
  }>(),
  {
    partLabels: () => ["A", "B", "C"] as [string, string, string],
  },
);

const shares = computed<number[]>(() => {
  const arr = props.parts.map((n) => Number(n) || 0);
  const total = arr.reduce((a, b) => a + b, 0) || 1;
  return arr.map((v) => v / total);
});
</script>

<style scoped>
.ratio3 { display: flex; flex-direction: column; gap: 4px; margin-top: 4px; }
.ratio3-row {
  display: grid; grid-template-columns: 24px 1fr 56px;
  align-items: center; gap: 8px; font-size: 12px;
}
.ratio3-label { color: var(--text-muted, #6b7280); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
.ratio3-track { background: var(--surface-section, #f3f4f6); height: 6px; border-radius: 3px; overflow: hidden; }
.ratio3-fill { background: var(--primary-color, #2563eb); height: 100%; }
.ratio3-value { text-align: right; color: var(--text-muted, #6b7280); }
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
</style>
